<template>
  <div class="w-full h-full flex justify-center items-center pending">
    <Select v-model="value"
            :dir="ctx.locale == 'ar'? 'rtl': ''" :disabled="readOnly">
      <SelectTrigger class="w-full"
                     :class="{
                          'bg-background': value == 'direct',
                          'bg-background': value == 'delivery',
                          'bg-background': value == 'pick_up',
                     }">
        <SelectValue/>
      </SelectTrigger>
      <SelectContent class="">
        <SelectItem value="direct">
          {{ t('orderTypes.direct') }}
        </SelectItem>
        <SelectItem value="delivery">
          {{ t('orderTypes.delivery') }}
        </SelectItem>
        <SelectItem value="pick_up">
          {{ t('orderTypes.pickUp') }}
        </SelectItem>
      </SelectContent>
    </Select>
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {useContext} from "@/plugins/context";
import {useI18n} from "vue-i18n";
import {i18nOrderMessages, Order} from "@/models/sales/Order";
import {ElMessage, ElMessageBox} from "element-plus";

export default defineComponent({
  setup() {
    const ctx = useContext();
    const {t} = useI18n({
      messages: {
        en: {...i18nOrderMessages.en},
        ar: {...i18nOrderMessages.ar}
      }
    })

    const order = ref<Order | null>(null);
    const value = ref('')
    const previousValue = ref('')
    const label = ref('')

    return {
      ctx,
      t,
      order,
      value,
      previousValue,
      label,
    }
  },
  components: {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
  },
  props: ['data', 'readOnly'],
  mounted() {
    /* @ts-ignore */
    this.order = (this.params?.data || this.$props.data) as Order;
    if (!this.order) {
      return;
    }
    this.value = this.order.orderType;
    this.previousValue = this.value;
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.previousValue != newVal) {
          this.order.orderType = newVal;
          this.onChangeType(newVal)
        }
      }
    },
  },
  methods: {
    onChangeType(event: any) {
      ElMessageBox.confirm(this.t('dialogs.confirmAction'), this.t('dialogs.warning'), {
        confirmButtonText: this.t('dialogs.confirm'),
        cancelButtonText: this.t('dialogs.cancel'),
        type: 'warning'
      })
          .then(() => {
            this.$http
                .post<Order>(
                    `${Order.ENDPOINT}/change-order-type/${this.order.id}`,
                    this.order
                )
                .then((resp) => {
                  this.previousValue = this.value;

                  /* eslint-disable vue/no-mutating-props */
                  ElMessage({
                    type: 'success',
                    message: this.t('dialogs.msgUpdated')
                  })
                })
                .catch(() => {
                  this.value = this.previousValue;
                  ElMessage({
                    type: 'error',
                    message: 'error'
                  })
                })
          })
          .catch(() => {
            console.log('cancelled')
            this.value = this.previousValue;
          })
    }
  }
})
</script>
<style>
</style>
